import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class ResponseToCallAnswerForm extends AppForm {
  constructor() {
    super({
      description: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      })
    });
  }
}
